import React, { KeyboardEvent, useState } from "react";
import { CommonTabWrap } from "../../styles/StyledComponents/CommonTabWrap";
import NavigateIcon from "../icons/NavigateIcon";
import { ICommonTabProps } from "../interface";
import TabPanel from "./TabPanel";

const CommonTab: React.FC<ICommonTabProps> = ({
  tabList,
  orientation = "horizontal",
  ...props
}) => {
  const [value, setValue] = useState(0);

  const focusTab = (idx: number) => {
    const btn = document.getElementById(`custom-tab-${idx}`);
    btn?.focus();
  };

  const handleNext = () => {
    if (value !== tabList.length - 1) {
      const next = (value + 1) % tabList.length;
      setValue(next);
      focusTab(next);
    }
  };

  const handlePrev = () => {
    if (value !== 0) {
      const prev = (value - 1 + tabList.length) % tabList.length;
      setValue(prev);
      focusTab(prev);
    }
  };

  const handleKey = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "ArrowRight" || e.key === "ArrowDown") {
      e.preventDefault();
      handleNext();
    }
    if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
      e.preventDefault();
      handlePrev();
    }
  };

  return (
    <CommonTabWrap orientation={orientation} {...props}>
      {/* ----- BUTTON BAR ----- */}
      <div className="tab_list_wrap_outer">
        <button
          onClick={handlePrev}
          className={`tabsnavigate_Btns prevBtn ${value === 0 ? "disableBtn" : ""}`}
          aria-label="Previous Tab"
        >
          <NavigateIcon />
        </button>
        <div
          className="tabListWrap"
          role="tablist"
          aria-orientation={orientation}
          onKeyDown={handleKey}
        >
          {tabList.map((item, idx) => (
            <button
              key={idx}
              type="button"
              role="tab"
              id={`custom-tab-${idx}`}
              aria-controls={`custom-tabpanel-${idx}`}
              aria-selected={value === idx}
              className={`tab_btn ${value === idx ? "active" : ""}`}
              onClick={() => setValue(idx)}
            >
              {item.tabLabel}
            </button>
          ))}
        </div>
        <button
          onClick={handleNext}
          className={`tabsnavigate_Btns nextBtn ${value === tabList.length - 1 ? "disableBtn" : ""}`}
          aria-label="Next Tab"
        >
          <NavigateIcon />
        </button>
      </div>

      {/* ----- PANELS ----- */}
      <div className="panel_list_wrap">
        {tabList.map((item, idx) => (
          <TabPanel key={idx} value={value} index={idx}>
            {item.tabPanel}
          </TabPanel>
        ))}
      </div>
    </CommonTabWrap>
  );
};

export default CommonTab;
